import WorthyApi from './worthyApi'
import { authenticatorUrl } from 'helpers/ApplicationHelper'

export class Authenticator {
  static refreshToken() {
    const url = authenticatorUrl('seller/refresh-token')
    return WorthyApi._httpReq('post', url)
  }

  static login(email, password) {
    const url = authenticatorUrl('seller/login')
    return WorthyApi._httpReq('post', url, { email, password })
  }

  static oneTimePassword(email, medium) {
    const url = authenticatorUrl('seller/one-time-password')
    return WorthyApi._httpReq('post', url, { email, medium, codeLength: 6 })
  }

  static otpLogin(email, code, medium, requestId) {
    const url = authenticatorUrl('seller/otp-login')
    return WorthyApi._httpReq('post', url, { email, code, requestId, medium })
  }

  static loginWithGoogle(credential) {
    const url = authenticatorUrl('seller/login-with-google')
    return WorthyApi._httpReq('post', url, { credential })
  }
}
